import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Row,
  Table,
  Tag,
} from "antd";
import Search from "antd/es/input/Search";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

import inquiryApi from "../../../apis/Inquiry.api";
import productApi from "../../../apis/Product.api";
import pushApi from "../../../apis/Push.api";
import userApi from "../../../apis/User.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

import RecommendProductComponent from "./RecommendProductComponent";

const { Panel } = Collapse;

const InquiryManageComponent = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [inquiryAnswer, setInquiryAnswer] = useState("");
  const [inquiryAnswerValidation, setInquiryAnswerValidation] = useState(false);
  const [recommendInquiryAnswer, setRecommendInquiryAnswer] = useState({
    greetings: "",
    additional: "",
  });
  const [inquiryEndType, setInquiryEndType] = useState(false);
  const [convertInquiryList, setConvertInquiryList] = useState([]);
  const [inquiryList, setInquiryList] = useState([]);
  const [inquiryAnswerList, setInquiryAnswerList] = useState([]);
  const [answeredInquiryList, setAnsweredInquiryList] = useState([]);
  const [waitInquiryList, setWaitInquiryList] = useState([]);
  const [currentInquiry, setCurrentInquiry] = useState({});
  const [selectedReasonRowKey, setSelectedReasonRowKey] = useState([]);
  const [selectedReasonRow, setSelectedReasonRow] = useState([]);
  const [selectedReasonList, setSelectedReasonList] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [selectedNutrientsList, setSelectedNutrientsList] = useState([]);
  const [recommendReasonList, setRecommendReasonList] = useState([]);
  const [nutrientsList, setNutrientsList] = useState({
    vitamin: [],
    mineral: [],
    nutrition: [],
  });
  const [productItemList, setProductItemList] = useState([]);
  const [checkAlert, setCheckAlert] = useState(false);
  const [error, setError] = useState("");
  // const searchReasonInput = useRef(null)
  const searchInput = useRef(null);
  const bottomRef = useRef(null);

  const reasonRowSelection = {
    selectedRowKeys: selectedReasonRowKey,
    onSelect: (record) => {
      let editTotalRow = [];
      let editRow = [];
      let editRowKey = [];
      const greetingsList = recommendInquiryAnswer.greetings.split(":)");
      const splitted = greetingsList[1].split("\n");
      const findReasonStrIdx = splitted.findIndex((str) =>
        str.includes("위와 같은 이유로"),
      );
      const greetingsStart = greetingsList[0] + ":)";
      const greetingsEnd = splitted.slice(findReasonStrIdx).join("\n");
      const copyReasonList = splitted.slice(0, findReasonStrIdx);
      if (copyReasonList?.length > 2 && copyReasonList[0] === "") {
        copyReasonList.shift();
      }
      let reasonStr = copyReasonList.join("\n");
      const reasonList = reasonStr.split("\n").filter((str) => str !== "");
      const selectReasonList = selectedReasonList.map(
        (reason) => reason.reason,
      );
      if (selectReasonList.includes(record.reason)) {
        editTotalRow = selectedReasonList.filter(
          (row) => row.reason !== record.reason,
        );
        editRow = selectedReasonRow.filter(
          (row) => row.reason !== record.reason,
        );
        editRowKey = selectedReasonRowKey.filter((key) => key !== record.id);
      } else {
        editTotalRow = [...selectedReasonList, record];
        editRow = [...selectedReasonRow, record];
        editRowKey = [...selectedReasonRowKey, record.id];
      }
      for (const row of editTotalRow) {
        if (!reasonList.includes(row.reason)) {
          reasonStr += `${
            row.reason.includes("XX")
              ? row.reason.replaceAll("XX", currentInquiry.created_by_name)
              : row.reason
          }\n`;
        } else {
          const findIdx = reasonList.findIndex(
            (reason) => reason === row.reason,
          );
          if (findIdx !== -1) {
            reasonList.splice(findIdx, 1);
          }
        }
      }
      if (reasonList?.length > 0) {
        for (const reason of reasonList) {
          reasonStr = reasonStr.replace(`${reason}\n`, "");
        }
      }
      if (reasonStr === "\n") {
        reasonStr = "";
      }
      setSelectedReasonRowKey(editRowKey);
      setSelectedReasonRow(editRow);
      setSelectedReasonList(editTotalRow);
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings:
          greetingsStart +
          "\n" +
          reasonStr +
          "\n" +
          (greetingsEnd.includes(":)") ? greetingsEnd : greetingsEnd + ":) )"),
      });
    },
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record) => {
      let editTotalRow = [];
      let editRow = [];
      let editRowKey = [];
      const greetingsList =
        recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
      let productNameStr = greetingsList[1].split("추천드립니다.")[0];
      const productNameList = productNameStr.split("\n");
      if (productNameList?.length === 1 && productNameList[0] === "") {
        productNameList.pop();
      }
      const productIdList = selectedProductList.map(
        (product) => product.product_id,
      );
      if (productIdList.includes(record.product_id)) {
        editTotalRow = selectedProductList.filter(
          (row) => row.product_id !== record.product_id,
        );
        editRow = selectedRow.filter(
          (row) => row.product_id !== record.product_id,
        );
        editRowKey = selectedRowKey.filter((key) => key !== record.product_id);
      } else {
        editTotalRow = [...selectedProductList, record];
        editRow = [...selectedRow, record];
        editRowKey = [...selectedRowKey, record.product_id];
      }
      for (const row of editTotalRow) {
        if (!productNameStr.includes(row.product_name)) {
          productNameStr += `"[${row.product_brand_name}] ${row.product_name}"\n`;
        } else {
          const findIdx = productNameList.findIndex((productName) =>
            productName.includes(row.product_name),
          );
          if (findIdx !== -1) {
            productNameList.splice(findIdx, 1);
          }
        }
        if (!row.hasOwnProperty("content")) {
          if (row.information_3 !== null) {
            row["content"] =
              row.information_1 +
              "\n\n" +
              row.information_2 +
              "\n\n" +
              row.information_3;
          } else if (row.information_2 !== null) {
            row["content"] = row.information_1 + "\n\n" + row.information_2;
          } else if (row.information_1 !== null) {
            row["content"] = row.information_1;
          } else {
            row["content"] = null;
          }
        }
        if (!row.hasOwnProperty("recommend_tag")) {
          row["recommend_tag"] = "";
        }
      }
      productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
      if (productNameList?.length > 0) {
        for (const productName of productNameList) {
          const deleteName = productName.replace(/(["'])\s/gim, `"`);
          productNameStr = productNameStr.replace(`${deleteName}\n`, "");
        }
      }
      productNameStr = productNameStr + "추천드립니다.";
      const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
      if (lastIdx !== -1) {
        productNameStr =
          productNameStr.substring(0, lastIdx) +
          " " +
          productNameStr.substring(lastIdx + 1);
      }
      setSelectedRowKey(editRowKey);
      setSelectedRow(editRow);
      setSelectedProductList(editTotalRow);
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings:
          greetingsList[0] +
          "이에 관련한 영양제로는\n" +
          productNameStr +
          (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
          greetingsList[1].split("추천드립니다.")[1],
      });
    },
  };
  const reasonColumns = [
    {
      title: "추천이유",
      dataIndex: "reason",
      key: "reason",
    },
  ];
  const columns = [
    {
      title: "브랜드명",
      dataIndex: "product_brand_name",
      key: "product_brand_name",
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
    },
  ];

  useEffect(() => {
    getNutrientList();
    getReadInquiryList("", props.location.state);
    handleSearchRecommendReason("");
    handleSearch("");
  }, []);

  useEffect(() => {
    if (inquiryEndType) {
      // 답변완료
      if (answeredInquiryList?.length > 0) {
        setCurrentInquiry(answeredInquiryList[0]);
      } else {
        setCurrentInquiry({});
      }
    } else {
      // 대기중
      if (waitInquiryList?.length > 0) {
        setCurrentInquiry(waitInquiryList[0]);
      } else {
        setCurrentInquiry({});
      }
    }
  }, [inquiryEndType]);

  useEffect(() => {
    if (currentInquiry.id) {
      getInquiryAnswer();
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings: `안녕하세요, ${currentInquiry.created_by_name}님!\n당신의 영양제 헬시팀입니다 :)\n\n위와 같은 이유로 ${currentInquiry.created_by_name}님께는 필요한 것으로 분석되며, 이에 관련한 영양제로는\n추천드립니다.`,
        additional: `제품에 대해 자세히 살펴보실 수 있도록 하단에 링크를 첨부해드리니 도움이 되시길 바라겠습니다 :)\n\n마침 인플루언서 "인플루언서명"님과의 협업을 통해 상담을 진행하신 분에 한해 7일 동안 사용하실 수 있는 10,000원 할인쿠폰을 제공해드리고 있으니 구매에 참고하시면 좋겠습니다!\n\n당신의 영양제 헬시팀의 영양제 추천이 도움이 되셨길 바라며, 당신의 매일이 건강했으면 좋겠습니다!\n\n감사합니다. 당신의 영양제 :)\n\n(${currentInquiry.created_by_name}께 당신의 영양제에서 추천드리는 제품은 치료를 목적으로 하는 의약품이 아님을 알려드립니다.)`,
      });
    }
  }, [currentInquiry]);

  useEffect(() => {
    convertInquiryByTime();
  }, [inquiryList]);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollTop = bottomRef.current.scrollHeight;
    }
  }, [convertInquiryList]);

  const getNutrientList = async () => {
    setIsLoading(true);
    try {
      const res = await productApi.readNutrientList();
      if (res.code === 200) {
        setNutrientsList({
          ...nutrientsList,
          vitamin: res.result.vitamin,
          mineral: res.result.mineral,
          nutrition: res.result.nutrition,
        });
      } else {
        throw `영양소 정보를 불러오는데 실패하였습니다. 다시 시도해주시길 바랍니다.`;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  /**
   * 답변목록 가져오기
   * @param {*} offset
   * @param {*} PageSize
   * @param {*} searchType
   * @param {*} searchText
   * @param {*} answerStatusFilter
   * @param {*} sortFilter
   */
  const getReadInquiryList = async (type = "", selectInquiryId = null) => {
    setIsLoading(true);
    try {
      const res = await inquiryApi.readInquiryListForAdmin();
      if (res.code === 200) {
        const convertWaitInquiryList = res.result.unAnsweredInquiryList;
        const convertAnsweredInquiryList = res.result.inquiryList;

        setAnsweredInquiryList(convertAnsweredInquiryList);
        setWaitInquiryList(convertWaitInquiryList);
        if (inquiryEndType) {
          // 답변완료
          if (
            convertAnsweredInquiryList?.length > 0 &&
            (!currentInquiry.id || type === "answerComplete")
          ) {
            setCurrentInquiry(convertAnsweredInquiryList[0]);
          }
        } else {
          // 대기중
          if (convertWaitInquiryList?.length > 0 && selectInquiryId) {
            const findInquiryIdx = convertWaitInquiryList.findIndex(
              (inquiry) => inquiry.id === selectInquiryId,
            );
            if (findInquiryIdx !== -1) {
              setCurrentInquiry(convertWaitInquiryList[findInquiryIdx]);
            } else {
              setCurrentInquiry(convertWaitInquiryList[0]);
            }
            history.replace({ state: null });
          } else if (
            convertWaitInquiryList?.length > 0 &&
            (!currentInquiry.id || type === "answerComplete")
          ) {
            setCurrentInquiry(convertWaitInquiryList[0]);
          }
          // if(convertInquiryList?.length>0 && !currentInquiry.id){
          //     setCurrentInquiry(convertInquiryList[0])
          // }
        }
      } else {
        throw `추천문의리스트를 읽어오지 못했습니다. 다시 시도해주십시오.`;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  const getInquiryAnswer = async () => {
    let answerRes = await inquiryApi.getInquiryAnswer(currentInquiry.user_id);
    if (answerRes.code === 200) {
      setInquiryAnswerList([...answerRes.result]);
      getInquiryList();
      return answerRes.code;
    }
  };

  const getInquiryList = async () => {
    let param = {
      user_id: currentInquiry.user_id,
    };

    const inquiryRes = await inquiryApi.readUserInquiryList(param);
    if (inquiryRes.code === 200) {
      setInquiryList(inquiryRes.result.inquiryList);
    }
  };

  /**
   * 답변완료처리
   */
  const answerComplete = async (userId) => {
    if (
      window.confirm(
        "해당 문의에 대한 대화를 종료하시겠습니까? 확인을 누르시면 문의자에게 상담 종료 안내 메세지가 보내집니다.",
      )
    ) {
      setIsLoading(true);
      try {
        const res = await inquiryApi.inquiryAnswerComplete(userId, user.id);
        if (res.code === 200) {
          alert("해당 문의에 대한 대화를 종료했습니다.");
          recommendProductInitial();
          getReadInquiryList("answerComplete");
          setIsLoading(false);
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        alert(error);
      }
    }
  };

  /**
   * 답변 완료 시 카카오 알림톡 보내기
   * @param user_id
   * @returns {Promise<void>}
   */
  const kakaoSendInquiry = async (param) => {
    setIsLoading(true);
    try {
      setError("");
      const res = await userApi.getUserInfo(param.inquiryInfo.created_by);
      if (res.code === 200) {
        param["user"] = res.result;
        if (res.result.provider && res.result.provider !== "guest") {
          delete param.inquiryInfo.full_content;
          console.log("Member  kakaoSendInquiry", param);
          await pushApi.kakaoForInquiryMember(param);
        } else {
          param.inquiryInfo.content = param.inquiryInfo.full_content;
          delete param.inquiryInfo.full_content;
          console.log("NonMember  kakaoSendInquiry", param);
          await pushApi.kakaoForInquiryNonMember(param);
        }
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
    }
  };

  const recommendProductAnswer = async () => {
    if (
      window.confirm(
        `${currentInquiry.created_by_name}님께 해당 상품들은 추천하시겠습니까?`,
      )
    ) {
      setIsLoading(true);
      try {
        let inquiryAnswerList = [];
        let productRecommendStr = "";
        let productUrlStr = "";
        if (recommendInquiryAnswer.greetings?.length !== 0) {
          const startAnswer = {
            inquiry_id: currentInquiry.id,
            content: recommendInquiryAnswer.greetings,
          };
          inquiryAnswerList.push(startAnswer);
        }
        for (const row of selectedProductList) {
          const recommendProduct = {
            inquiry_id: currentInquiry.id,
            content:
              row.hasOwnProperty("content") && typeof row.content === "string"
                ? row.content.trim()?.length === 0
                  ? null
                  : row.content.trim()
                : null,
            recommend_id: row.product_id,
            recommend_target_id: row.target_id,
            recommend_tag: row.hasOwnProperty("recommend_tag")
              ? row.recommend_tag
              : null,
          };
          if (
            row.hasOwnProperty("content") &&
            typeof row.content === "string" &&
            row.content.trim()?.length !== 0
          ) {
            productRecommendStr += row.content.trim();
            productRecommendStr += "\n\n";
          }
          productUrlStr += `[${row.product_brand_name}] ${row.product_name}\n`;
          productUrlStr += `https://app.dangyoung.com/products/${row.target_id}\n\n`;
          inquiryAnswerList.push(recommendProduct);
        }
        if (recommendInquiryAnswer.additional?.length !== 0) {
          const additionalAnswer = {
            inquiry_id: currentInquiry.id,
            content: recommendInquiryAnswer.additional,
            additional_comments_status: true,
          };
          inquiryAnswerList.push(additionalAnswer);
        }
        const answerParam = {
          inquiryAnswerList: inquiryAnswerList,
          created_by: currentInquiry.user_id,
          answer_created_by: user.id,
        };
        console.log("inquiryAnswerList", inquiryAnswerList);
        let fullContent =
          recommendInquiryAnswer.greetings +
          "\n\n" +
          (productRecommendStr?.length !== 0
            ? productRecommendStr + "\n"
            : "") +
          productUrlStr +
          "\n" +
          recommendInquiryAnswer.additional.replace(
            "또 다른 상품 추천을 받고 싶으시다면 상담 종료 후 다시 질문해 주세요.\n만약 궁금하신 사항이 있으시다면 이어서 질문하기로 상담 요청 부탁 드립니다!\n",
            "",
          );
        if (
          currentInquiry.user_provider === "guest" &&
          fullContent?.length > 850
        ) {
          throw `현재 비회원 문의자에게 보내질 알림톡의 내용이 850자가 넘습니다. 답변 내용을 수정해주시길 바랍니다.`;
        }
        const res = await inquiryApi.inquiryAnswerRecommend(answerParam);
        if (res.code === 200) {
          alert(
            `${currentInquiry.created_by_name}님께 선택한 상품 추천을 정상적으로 완료했습니다.`,
          );
          let memberContent =
            recommendInquiryAnswer.greetings +
            "\n\n" +
            (productRecommendStr?.length !== 0
              ? productRecommendStr + "\n"
              : "") +
            recommendInquiryAnswer.additional;
          // kakao 알림 보내기
          const kakaoAlertParam = {
            inquiryInfo: {
              checking_status: "chat",
              created_by_name: currentInquiry.created_by_name,
              question_date_str: moment(currentInquiry.created_at).format(
                "YYYY년 MM월 DD일 HH시 mm분",
              ),
              content:
                memberContent?.length > 500
                  ? memberContent.substr(0, 500) + "..."
                  : memberContent,
              created_by: currentInquiry.user_id,
              full_content: fullContent,
            },
          };
          kakaoSendInquiry(kakaoAlertParam);
          recommendProductInitial();
          getReadInquiryList("answerComplete");
          setIsLoading(false);
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        alert(error);
      }
    }
  };

  /**
   * handleSearch - 추천이유 검색
   */
  const handleSearchRecommendReason = async (searchWord) => {
    setIsLoading(true);
    try {
      let param = {
        searchKeywords: searchWord,
      };
      const res = await inquiryApi.searchRecommendReason(param);
      if (res.code === 200) {
        if (res.result?.length > 0) {
          let rowKeyList = [];
          let rowList = [];
          for (const reason of selectedReasonList) {
            if (res.result.some((result) => result.id === reason.id)) {
              rowKeyList.push(reason.id);
              rowList.push(reason);
            }
          }
          setSelectedReasonRowKey(rowKeyList);
          setSelectedReasonRow(rowList);
        } else {
          setSelectedReasonRowKey([]);
          setSelectedReasonRow([]);
        }
        setRecommendReasonList(res.result);
        setIsLoading(false);
      } else {
        throw "추천 이유를 찾아오지 못했습니다. 다시 시도해주세요.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  /**
   * handleSearch - 상품 검색
   */
  const handleSearch = async (searchWord) => {
    setIsLoading(true);
    try {
      const res = await productApi.readProductListAll(
        0,
        "",
        searchWord,
        "",
        "product_id",
        "desc",
        user.id === 724 ? 1 : user.id,
      );
      if (res.code === 200) {
        if (res.result?.length > 0) {
          let rowKeyList = [];
          let rowList = [];
          for (const product of selectedProductList) {
            if (
              res.result.some(
                (result) => result.product_id === product.product_id,
              )
            ) {
              rowKeyList.push(product.product_id);
              rowList.push(product);
            }
          }
          setSelectedRowKey(rowKeyList);
          setSelectedRow(rowList);
        } else {
          setSelectedRowKey([]);
          setSelectedRow([]);
        }
        setProductItemList(res.result);
        setIsLoading(false);
      } else {
        throw "상품 정보를 찾아오지 못했습니다. 다시 시도해주세요.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  /**
   * 문의 답변 제출하기
   * @returns {Promise<void>}
   */
  const submitInquiryAnswer = async () => {
    setIsLoading(true);
    console.log("submitInquiryAnswer", currentInquiry);
    const inquiryAnswer = document.getElementById("answer-textarea").innerHTML;
    let param = {
      inquiry_id: currentInquiry.id,
      answer_status: 0,
      content: inquiryAnswer,
      // content: textarea,
      created_by: currentInquiry.user_id,
      answer_created_by: user.id,
    };
    // console.log(param, inquiryAnswer);
    let res = await inquiryApi.createInquiryAnswer(param);
    if (res.code === 200) {
      // setIsLoading(false)
      window.alert("새로운 답변이 등록되었습니다");
      if (checkAlert) {
        // kakao 알림 보내기
        const kakaoAlertParam = {
          inquiryInfo: {
            checking_status: "chat",
            created_by_name: currentInquiry.created_by_name,
            question_date_str: moment(currentInquiry.created_at).format(
              "YYYY년 MM월 DD일 HH시 mm분",
            ),
            content:
              inquiryAnswer?.length > 1000
                ? inquiryAnswer.substr(0, 997) + "..."
                : inquiryAnswer,
            created_by: currentInquiry.user_id,
            full_content: inquiryAnswer,
          },
        };
        kakaoSendInquiry(kakaoAlertParam);
      }
      getInquiryAnswer();
      getReadInquiryList();
      setInquiryAnswer(null);
      setInquiryAnswerValidation(false);
      setCheckAlert(false);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setError(error);
      window.alert(
        "오류가 발생해 해답 답변을 보내지 못했습니다. 관리자에게 문의하세요",
      );
    }
  };

  /**
   * 시간순서로 정렬하기 ( 추후에 백앤드에서 처리하기 )
   */
  const convertInquiryByTime = () => {
    if (inquiryList?.length > 0) {
      let convertList = inquiryList;
      convertList.push(...inquiryAnswerList);
      convertList.sort(function (a, b) {
        if (a.created_at > b.created_at) {
          return 1;
        }
        if (a.created_at < b.created_at) {
          return -1;
        }
        return 0;
      });
      setConvertInquiryList(convertList);
    }
  };

  /**
   * 나이변환하기
   * @param user
   * @returns {{convertAgeTitle: string, convertAgeFigure: string}}
   */
  const convertAge = (user_age, user_birthday) => {
    let convertAgeFigure = "";

    if (user_age < 2) {
      let diffDay = moment().diff(moment(user_birthday), "days");
      if (diffDay < 180) {
        convertAgeFigure = diffDay + "일";
      } else {
        convertAgeFigure =
          moment().diff(moment(user_birthday), "months") + "개월";
      }
    } else {
      convertAgeFigure = parseInt(user_age) + "세";
    }

    return convertAgeFigure;
  };

  /**
   * QA 텍스트 Change
   */
  const handleTextChange = (e) => {
    if (e.target.value !== "") {
      setInquiryAnswer(e.target.value);
      // setInquiryAnswerValidation(true);
    } else {
      setInquiryAnswer("");
      // setInquiryAnswerValidation(false);
    }
  };

  useEffect(() => {
    if (inquiryAnswer?.length > 0 && !inquiryAnswerValidation) {
      setInquiryAnswerValidation(true);
    } else if (inquiryAnswer?.length === 0 && inquiryAnswerValidation) {
      setInquiryAnswerValidation(false);
    }
  }, [inquiryAnswer]);

  /**
   * handleRowEvent - 추천 이유 선택
   */
  const handleReasonRowEvent = (record) => {
    return {
      onClick: (_) => {
        let editTotalRow = [];
        let editRow = [];
        let editRowKey = [];
        const greetingsList = recommendInquiryAnswer.greetings.split(":)");
        const splitted = greetingsList[1].split("\n");
        const findReasonStrIdx = splitted.findIndex((str) =>
          str.includes("위와 같은 이유로"),
        );
        const greetingsStart = greetingsList[0] + ":)";
        const greetingsEnd = splitted.slice(findReasonStrIdx).join("\n");
        const copyReasonList = splitted.slice(0, findReasonStrIdx);
        if (copyReasonList?.length > 2 && copyReasonList[0] === "") {
          copyReasonList.shift();
        }
        let reasonStr = copyReasonList.join("\n");
        const reasonList = reasonStr.split("\n").filter((str) => str !== "");
        const selectReasonList = selectedReasonList.map(
          (reason) => reason.reason,
        );
        if (selectReasonList.includes(record.reason)) {
          editTotalRow = selectedReasonList.filter(
            (row) => row.reason !== record.reason,
          );
          editRow = selectedReasonRow.filter(
            (row) => row.reason !== record.reason,
          );
          editRowKey = selectedReasonRowKey.filter((key) => key !== record.id);
        } else {
          editTotalRow = [...selectedReasonList, record];
          editRow = [...selectedReasonRow, record];
          editRowKey = [...selectedReasonRowKey, record.id];
        }
        for (const row of editTotalRow) {
          if (!reasonList.includes(row.reason)) {
            reasonStr += `${
              row.reason.includes("XX")
                ? row.reason.replaceAll("XX", currentInquiry.created_by_name)
                : row.reason
            }\n`;
          } else {
            const findIdx = reasonList.findIndex(
              (reason) => reason === row.reason,
            );
            if (findIdx !== -1) {
              reasonList.splice(findIdx, 1);
            }
          }
        }
        if (reasonList?.length > 0) {
          for (const reason of reasonList) {
            reasonStr = reasonStr.replace(`${reason}\n`, "");
          }
        }
        if (reasonStr === "\n") {
          reasonStr = "";
        }
        setSelectedReasonRowKey(editRowKey);
        setSelectedReasonRow(editRow);
        setSelectedReasonList(editTotalRow);
        setRecommendInquiryAnswer({
          ...recommendInquiryAnswer,
          greetings:
            greetingsStart +
            "\n" +
            reasonStr +
            "\n" +
            (greetingsEnd.includes(":)")
              ? greetingsEnd
              : greetingsEnd + ":) )"),
        });
      },
    };
  };

  /**
   * 영양소 선택하기
   */
  const handleNutrientsSelect = (e) => {
    const { value, checked } = e.target;
    let editSelected = [];
    const greetingsList = recommendInquiryAnswer.greetings.split("님께는 ");
    const splittedGreetingList = greetingsList[1].split("필요한 것으로");
    const greetingsStart = greetingsList[0] + "님께는 ";
    const greetingsEnd = splittedGreetingList[1];
    if (checked) {
      const addNutrients = {
        id: value.nutrient_id,
        name: value.nutrient_name,
      };
      editSelected = [...selectedNutrientsList, addNutrients];
    } else {
      let currProductList = [...selectedProductList];
      for (const product of currProductList) {
        if (
          product.hasOwnProperty("recommend_tag") &&
          product.recommend_tag.includes(value.nutrient_id)
        ) {
          const tagList = product.recommend_tag.split(",");
          const findIdx = tagList.findIndex((tag) => tag === value.nutrient_id);
          if (findIdx !== -1) {
            tagList.splice(findIdx, 1);
          }
          product.recommend_tag = tagList.join(",");
        }
      }
      setSelectedProductList(currProductList);
      editSelected = selectedNutrientsList.filter(
        (nutrients) => nutrients.id !== value.nutrient_id,
      );
    }
    const nutrientsNameList = editSelected.map((select) => select.name);
    setSelectedNutrientsList(editSelected);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsStart +
        nutrientsNameList.join(", ") +
        (editSelected?.length === 0 ? "필요한 것으로" : " 필요한 것으로") +
        greetingsEnd,
    });
  };

  /**
   * 선택상품별 영양소 선택하기
   */
  const handleNutrientsSelectForProduct = (e, currIdx) => {
    const { value, checked } = e.target;
    const currSelectedProductList = [...selectedProductList];
    if (checked) {
      if (
        !currSelectedProductList[currIdx].hasOwnProperty("recommend_tag") ||
        currSelectedProductList[currIdx]["recommend_tag"] === ""
      ) {
        currSelectedProductList[currIdx]["recommend_tag"] = value;
      } else {
        currSelectedProductList[currIdx]["recommend_tag"] =
          currSelectedProductList[currIdx]["recommend_tag"] + "," + value;
      }
    } else {
      const tagList =
        currSelectedProductList[currIdx]["recommend_tag"].split(",");
      const findIdx = tagList.findIndex((tag) => tag === value);
      if (findIdx !== -1) {
        tagList.splice(findIdx, 1);
      }
      currSelectedProductList[currIdx]["recommend_tag"] = tagList.join(",");
    }
    setSelectedProductList(currSelectedProductList);
  };

  /**
   * 영양소 태그 삭제하기
   */
  const handleDeleteNutrients = (id, e) => {
    e.preventDefault();
    let currProductList = [...selectedProductList];
    const greetingsList = recommendInquiryAnswer.greetings.split("님께는 ");
    const splittedGreetingList = greetingsList[1].split("필요한 것으로");
    const greetingsStart = greetingsList[0] + "님께는 ";
    const greetingsEnd = splittedGreetingList[1];
    const deleteNutrients = selectedNutrientsList.filter(
      (nutrients) => nutrients.id !== id,
    );
    const nutrientsNameList = deleteNutrients.map((select) => select.name);
    for (const product of currProductList) {
      if (
        product.hasOwnProperty("recommend_tag") &&
        product.recommend_tag.includes(id)
      ) {
        const tagList = product.recommend_tag.split(",");
        const findIdx = tagList.findIndex((tag) => tag === id);
        if (findIdx !== -1) {
          tagList.splice(findIdx, 1);
        }
        product.recommend_tag = tagList.join(",");
      }
    }
    setSelectedNutrientsList(deleteNutrients);
    setSelectedProductList(currProductList);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsStart +
        nutrientsNameList.join(", ") +
        (deleteNutrients?.length === 0 ? "필요한 것으로" : " 필요한 것으로") +
        greetingsEnd,
    });
  };

  /**
   * handleRowEvent - 상품 선택
   */
  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        let editTotalRow = [];
        let editRow = [];
        let editRowKey = [];
        const greetingsList =
          recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
        let productNameStr = greetingsList[1].split("추천드립니다.")[0];
        const productNameList = productNameStr.split("\n");
        if (productNameList?.length === 1 && productNameList[0] === "") {
          productNameList.pop();
        }
        const productIdList = selectedProductList.map(
          (product) => product.product_id,
        );
        if (productIdList.includes(record.product_id)) {
          editTotalRow = selectedProductList.filter(
            (row) => row.product_id !== record.product_id,
          );
          editRow = selectedRow.filter(
            (row) => row.product_id !== record.product_id,
          );
          editRowKey = selectedRowKey.filter(
            (key) => key !== record.product_id,
          );
        } else {
          editTotalRow = [...selectedProductList, record];
          editRow = [...selectedRow, record];
          editRowKey = [...selectedRowKey, record.product_id];
        }
        for (const row of editTotalRow) {
          if (!productNameStr.includes(row.product_name)) {
            productNameStr += `"[${row.product_brand_name}] ${row.product_name}"\n`;
          } else {
            const findIdx = productNameList.findIndex((productName) =>
              productName.includes(row.product_name),
            );
            if (findIdx !== -1) {
              productNameList.splice(findIdx, 1);
            }
          }
          if (!row.hasOwnProperty("content")) {
            if (row.information_3 !== null) {
              row["content"] =
                row.information_1 +
                "\n\n" +
                row.information_2 +
                "\n\n" +
                row.information_3;
            } else if (row.information_2 !== null) {
              row["content"] = row.information_1 + "\n\n" + row.information_2;
            } else if (row.information_1 !== null) {
              row["content"] = row.information_1;
            } else {
              row["content"] = null;
            }
          }
          if (!row.hasOwnProperty("recommend_tag")) {
            row["recommend_tag"] = "";
          }
        }
        productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
        if (productNameList?.length > 0) {
          for (const productName of productNameList) {
            const deleteName = productName.replace(/(["'])\s/gim, `"`);
            productNameStr = productNameStr.replace(`${deleteName}\n`, "");
          }
        }
        productNameStr = productNameStr + "추천드립니다.";
        const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
        if (lastIdx !== -1) {
          productNameStr =
            productNameStr.substring(0, lastIdx) +
            " " +
            productNameStr.substring(lastIdx + 1);
        }
        setSelectedRowKey(editRowKey);
        setSelectedRow(editRow);
        setSelectedProductList(editTotalRow);
        setRecommendInquiryAnswer({
          ...recommendInquiryAnswer,
          greetings:
            greetingsList[0] +
            "이에 관련한 영양제로는\n" +
            productNameStr +
            (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
            greetingsList[1].split("추천드립니다.")[1],
        });
      },
    };
  };

  /**
   * 선택 상품 추천하기 validation
   */
  const validRecommendProduct = () => {
    if (selectedProductList?.length === 0 || inquiryEndType) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * 추천 상품 리스트 해제
   */
  const deleteRecommendProduct = (productId) => {
    const greetingsList =
      recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
    let productNameStr = greetingsList[1].split("추천드립니다.")[0];
    const productNameList = productNameStr.split("\n");
    if (productNameList?.length === 1 && productNameList[0] === "") {
      productNameList.pop();
    }

    const deletedProductList = selectedProductList.filter(
      (row) => row.product_id !== productId,
    );
    if (selectedRowKey.includes(productId)) {
      const deletedRowKeys = selectedRowKey.filter((key) => key !== productId);
      const deletedRows = selectedRow.filter(
        (row) => row.product_id !== productId,
      );
      setSelectedRowKey(deletedRowKeys);
      setSelectedRow(deletedRows);
    }
    for (const row of deletedProductList) {
      if (!productNameStr.includes(row.product_name)) {
        productNameStr += `"${row.product_name}"\n`;
      } else {
        const findIdx = productNameList.findIndex((productName) =>
          productName.includes(row.product_name),
        );
        if (findIdx !== -1) {
          productNameList.splice(findIdx, 1);
        }
      }
    }
    productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
    if (productNameList?.length > 0) {
      for (const productName of productNameList) {
        const deleteName = productName.replace(/(["'])\s/gim, `"`);
        productNameStr = productNameStr.replace(`${deleteName}\n`, "");
      }
    }
    productNameStr = productNameStr + "추천드립니다.";
    const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
    if (lastIdx !== -1) {
      productNameStr =
        productNameStr.substring(0, lastIdx) +
        " " +
        productNameStr.substring(lastIdx + 1);
    }
    setSelectedProductList(deletedProductList);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsList[0] +
        "이에 관련한 영양제로는\n" +
        productNameStr +
        (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
        greetingsList[1].split("추천드립니다.")[1],
    });
  };

  /**
   * 추천 상품 선택 이유 작성
   */
  const recommendProductReason = (idx, value) => {
    let currRow = [...selectedProductList];
    currRow[idx]["content"] = value;
    setSelectedProductList(currRow);
  };

  /**
   * 추천 상품 초기화
   */
  const recommendProductInitial = () => {
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings: `안녕하세요, ${currentInquiry.created_by_name}님!\n당신의 영양제 헬시팀입니다 :)\n\n위와 같은 이유로 ${currentInquiry.created_by_name}님께는 필요한 것으로 분석되며, 이에 관련한 영양제로는\n추천드립니다.\n\n(${currentInquiry.created_by_name}님의 목적과 고민에 맞춰 영양제 추천을 드리나, 당신의 영양제에서 추천드리는 제품은 치료를 목적으로 하는 의약품이 아님을 알려드립니다:) )`,
      additional: `제품에 대해 자세히 살펴보실 수 있도록 하단에 링크를 첨부해드리니 도움이 되시길 바라겠습니다 :)\n\n마침 인플루언서 "인플루언서명"님과의 협업을 통해 상담을 진행하신 분에 한해 7일 동안 사용하실 수 있는 10,000원 할인쿠폰을 제공해드리고 있으니 구매에 참고하시면 좋겠습니다!\n\n당신의 영양제 헬시팀의 영양제 추천이 도움이 되셨길 바라며, 당신의 매일이 건강했으면 좋겠습니다!\n\n감사합니다. 당신의 영양제 :)\n\n(${currentInquiry.created_by_name}께 당신의 영양제에서 추천드리는 제품은 치료를 목적으로 하는 의약품이 아님을 알려드립니다.)`,
    });
    setSelectedRow([]);
    setSelectedRowKey([]);
    setSelectedProductList([]);
    setSelectedReasonRow([]);
    setSelectedReasonRowKey([]);
    setSelectedReasonList([]);
    setSelectedNutrientsList([]);
    // searchReasonInput.current.state.value = null
    searchInput.current.state.value = null;
  };

  /**
   * 추천 상품 영양소 en -> kr
   */
  const changeNutrientsName = (nutrientsId) => {
    if (
      nutrientsList.vitamin?.length === 0 ||
      nutrientsList.mineral?.length === 0 ||
      nutrientsList.nutrition?.length === 0
    ) {
      return nutrientsId;
    } else {
      const findVitaminIdx = nutrientsList.vitamin.findIndex(
        (vitamin) => vitamin.nutrient_id === nutrientsId,
      );
      if (findVitaminIdx !== -1) {
        return nutrientsList.vitamin[findVitaminIdx].nutrient_name;
      } else {
        const findMineralIdx = nutrientsList.mineral.findIndex(
          (mineral) => mineral.nutrient_id === nutrientsId,
        );
        if (findMineralIdx !== -1) {
          return nutrientsList.mineral[findMineralIdx].nutrient_name;
        } else {
          const findNutritionIdx = nutrientsList.nutrition.findIndex(
            (nutrition) => nutrition.nutrient_id === nutrientsId,
          );
          if (findNutritionIdx !== -1) {
            return nutrientsList.nutrition[findNutritionIdx].nutrient_name;
          } else {
            return nutrientsId;
          }
        }
      }
    }
  };

  return (
    <div
      className="contentPage"
      style={{ margin: 24, padding: "17px 15px 20px" }}
    >
      <div className="inquiry-main-wrap">
        <div className="inquiry-main-menu-wrap">
          <div className="inquiry-main-menu-status-wrap">
            <div
              onClick={() => {
                setInquiryEndType(false);
                recommendProductInitial();
                setInquiryAnswer(null);
                setInquiryAnswerValidation(false);
                getReadInquiryList();
              }}
              className={
                inquiryEndType
                  ? "inquiry-main-menu-status-wait"
                  : "inquiry-main-menu-status-wait-active"
              }
            >
              <div className="inquiry-main-menu-status-wait-img">
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/${
                    inquiryEndType ? "wait_icon" : "wait_icon_active"
                  }.png`}
                />
              </div>
              대기중
            </div>
            <div className="inquiry-main-menu-status-divider">|</div>
            <div
              onClick={() => {
                setInquiryEndType(true);
                recommendProductInitial();
                setInquiryAnswer(null);
                setInquiryAnswerValidation(false);
                getReadInquiryList();
              }}
              className={
                inquiryEndType
                  ? "inquiry-main-menu-status-end-active"
                  : "inquiry-main-menu-status-end"
              }
            >
              <div className="inquiry-main-menu-status-end-img">
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/${
                    inquiryEndType ? "answer_icon_active" : "answer_icon"
                  }.png`}
                />
              </div>
              답변완료
            </div>
          </div>
          <div className="inquiry-main-menu-title-wrap">
            <div className="inquiry-main-menu-title">대화목록</div>
            <div className="inquiry-main-menu-sort">최신순</div>
          </div>
          <div className="inquiry-main-menu-contents-wrap">
            {waitInquiryList?.length > 0 && inquiryEndType === false && (
              <>
                {waitInquiryList.map((item, idx) => (
                  <div
                    key={`waitInquiryList-${idx}`}
                    onClick={() => {
                      setCurrentInquiry(item);
                      recommendProductInitial();
                      setInquiryAnswer(null);
                      setInquiryAnswerValidation(false);
                    }}
                    className={
                      currentInquiry.created_by === item.created_by
                        ? "inquiry-main-menu-content-wrap active"
                        : "inquiry-main-menu-content-wrap"
                    }
                    style={{
                      borderBottom:
                        idx === waitInquiryList?.length - 1
                          ? 0
                          : "solid 1px #ced4da",
                    }}
                  >
                    <Row justify="space-between" wrap={false}>
                      <Col flex="auto">
                        <div className="inquiry-main-menu-info">
                          {item.created_by_name}{" "}
                          {item.created_by_name !== "GUEST" &&
                          item.user_age !== 0
                            ? `/ ${convertAge(
                                item.user_age,
                                item.user_birthday,
                              )} / ${item.user_gender === 1 ? "남자" : "여자"}`
                            : ""}
                        </div>
                      </Col>
                      <Col flex="none">
                        <div
                          className={
                            "inquiry-main-menu-status" +
                            (!item.user_phone ? " status-red" : " status-green")
                          }
                        ></div>
                      </Col>
                    </Row>
                    <div className="inquiry-main-menu-content">
                      {item.content}
                    </div>
                    <div className="inquiry-main-menu-date">
                      {moment(item.created_at).format(`YY-MM-DD HH:mm`)}
                    </div>
                  </div>
                ))}
              </>
            )}
            {answeredInquiryList?.length > 0 && inquiryEndType === true && (
              <>
                {answeredInquiryList.map((item, idx) => (
                  <div
                    onClick={() => {
                      setCurrentInquiry(item);
                      recommendProductInitial();
                      setInquiryAnswer(null);
                      setInquiryAnswerValidation(false);
                    }}
                    className={
                      currentInquiry.created_by === item.created_by
                        ? "inquiry-main-menu-content-wrap active"
                        : "inquiry-main-menu-content-wrap"
                    }
                    style={{
                      borderBottom:
                        idx === answeredInquiryList?.length - 1
                          ? 0
                          : "solid 1px #ced4da",
                    }}
                  >
                    <div className="inquiry-main-menu-info">
                      {item.created_by_name}{" "}
                      {item.created_by_name !== "GUEST" && item.user_age !== 0
                        ? `/ ${convertAge(
                            item.user_age,
                            item.user_birthday,
                          )} / ${item.user_gender === 1 ? "남자" : "여자"}`
                        : ""}
                    </div>
                    <div className="inquiry-main-menu-content">
                      {item.content}
                    </div>
                    <div className="inquiry-main-menu-date">
                      {moment(item.created_at).format(`YY-MM-DD HH:mm`)}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="inquiry-main-content-wrap">
          <div className="inquiry-main-content-header-wrap">
            <div className="inquiry-main-content-info-wrap">
              <div className="inquiry-main-content-info-name">
                {currentInquiry.created_by_name}
              </div>
              {currentInquiry.created_by_name !== "GUEST" &&
              currentInquiry.user_age !== 0 ? (
                <div className="inquiry-main-content-info-info">
                  {convertAge(
                    currentInquiry.user_age,
                    currentInquiry.user_birthday,
                  )}{" "}
                  / {currentInquiry.user_gender === 1 ? "남자" : "여자"}
                </div>
              ) : null}
            </div>
            {!inquiryEndType ? (
              <div
                className="inquiry-main-content-info-status"
                onClick={() => answerComplete(currentInquiry.user_id)}
              >
                답변완료
              </div>
            ) : null}
          </div>
          <div ref={bottomRef} className="inquiry-main-content-chat-wrap">
            {convertInquiryList?.length > 0 && (
              <>
                {convertInquiryList.map((item, idx) => {
                  return (
                    <div key={`convertInquiryList-${idx}`}>
                      {item.created_by_name && (
                        <div className="user-inquiry-text-wrap">
                          <div className="user-inquiry-text">
                            {item.content}
                          </div>
                          <div className="inquiry-text-date">
                            {moment(item.created_at).format(`YY-MM-DD HH:mm`)}
                          </div>
                        </div>
                      )}
                      {!item.created_by_name &&
                        (item.recommend_target_id !== null ? (
                          <>
                            {console.log("read_status", item)}
                            {item.content && (
                              <div className="admin-inquiry-text-wrap">
                                <div style={{ alignSelf: "end" }}>
                                  <div className="inquiry-text-date">
                                    {item.hasOwnProperty("read_status")
                                      ? item.read_status
                                        ? "읽음"
                                        : ""
                                      : ""}
                                  </div>
                                  <div className="inquiry-text-date">
                                    {moment(item.created_at).format(
                                      `YY-MM-DD HH:mm`,
                                    )}
                                  </div>
                                </div>
                                <div className="admin-inquiry-text">
                                  {/*<div className="admin-inquiry-title-text">{`추천이유\n`}</div>*/}
                                  {item.content}
                                </div>
                              </div>
                            )}
                            <div className="admin-inquiry-text-wrap">
                              <div style={{ alignSelf: "end" }}>
                                <div className="inquiry-text-date">
                                  {item.hasOwnProperty("read_status")
                                    ? item.read_status
                                      ? "읽음"
                                      : ""
                                    : ""}
                                </div>
                                <div className="inquiry-text-date">
                                  {moment(item.created_at).format(
                                    `YY-MM-DD HH:mm`,
                                  )}
                                </div>
                              </div>
                              <div className="admin-inquiry-text recommend-product-img-wrap">
                                <img
                                  className="admin-inquiry-img-wrap"
                                  src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${item.recommend_target_id}.jpg`}
                                />
                                <Row
                                  justify="center"
                                  gutter={[0, 8]}
                                  className="admin-inquiry-nutrients-tag-wrap"
                                >
                                  {item.recommend_tag !== null &&
                                  item.recommend_tag !== "" ? (
                                    <>
                                      {item.recommend_tag
                                        .split(",")
                                        .map((tag, idx) => (
                                          <Tag
                                            key={`recommend_nutrients_${idx}`}
                                            className="admin-inquiry-nutrients-tag"
                                          >
                                            {changeNutrientsName(tag)}
                                          </Tag>
                                        ))}
                                    </>
                                  ) : null}
                                </Row>
                                <div className="admin-inquiry-recommend-product-text-wrap">
                                  <span className="admin-inquiry-product-name-text">
                                    {item.product_name}
                                  </span>
                                  &nbsp;추천드려요.
                                </div>
                              </div>
                            </div>
                          </>
                        ) : item.content === "itsyourimage" ? (
                          <div className="admin-inquiry-text-wrap">
                            <img
                              className="professional-img-wrap"
                              src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/professional.png`}
                            />
                          </div>
                        ) : item.content === "guest-image" ? (
                          <div className="admin-inquiry-text-wrap">
                            <img
                              className="guest-img-wrap"
                              src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/guest-image.png`}
                            />
                          </div>
                        ) : item.content.includes("$$") ? null : (
                          <div className="admin-inquiry-text-wrap">
                            <div style={{ alignSelf: "end" }}>
                              <div className="inquiry-text-date">
                                {item.hasOwnProperty("read_status")
                                  ? item.read_status
                                    ? "읽음"
                                    : ""
                                  : ""}
                              </div>
                              <div className="inquiry-text-date">
                                {moment(item.created_at).format(
                                  `YY-MM-DD HH:mm`,
                                )}
                              </div>
                            </div>
                            {item.content.includes("#%") ||
                            item.content.includes("#$") ? (
                              <div className="admin-inquiry-text">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.content
                                      .split("&amp")[0]
                                      .replaceAll(
                                        "#%",
                                        "<span class='admin-inquiry-highlight'>",
                                      )
                                      .replaceAll("%#", "</span>")
                                      .replaceAll(
                                        "#$",
                                        "<span class='admin-inquiry-bold'>",
                                      )
                                      .replaceAll("$#", "</span>"),
                                  }}
                                ></div>
                                <div>{item.content.split("&amp")[1]}</div>
                              </div>
                            ) : (
                              <div className="admin-inquiry-text">
                                {item.additional_comments_status ? (
                                  <div className="admin-inquiry-title-text">{`추가 코멘트\n`}</div>
                                ) : null}
                                {item.content.includes("&amp") ? (
                                  <>
                                    {item.content.split("&amp")[0]}&nbsp;
                                    <span className="admin-inquiry-help-text">
                                      {item.content.split("&amp")[1]}
                                    </span>
                                  </>
                                ) : item.content === "new" ? (
                                  item.checking_status === "product" ? (
                                    "상품 문의 선택"
                                  ) : item.checking_status === "delivery" ? (
                                    "배송 문의 선택"
                                  ) : item.checking_status === "exchange" ? (
                                    "환불·취소·교환 선택"
                                  ) : item.checking_status === "recommend" ? (
                                    "영양제 추천 받기 선택"
                                  ) : item.checking_status === "dangyoung" ? (
                                    "당신의 영양제 소개 선택"
                                  ) : item.checking_status === "claim" ? (
                                    "제안·오류 신고 선택"
                                  ) : item.checking_status === "etc" ? (
                                    "기타 문의 선택"
                                  ) : (
                                    "상품 문의\n배송 문의\n환불·취소·교환\n영양제 추천 받기\n당신의 영양제 소개\n제안·오류 신고\n기타 문의"
                                  )
                                ) : item.content === "next" ? (
                                  item.checking_status === null ? (
                                    "이어서 질문하기 / 처음으로 가기"
                                  ) : item.checking_status === "next" ? (
                                    "이어서 질문하기 선택"
                                  ) : (
                                    "처음으로 가기 선택"
                                  )
                                ) : item.content === "isUser" ? (
                                  item.checking_status === null ? (
                                    "로그인하기 / 비회원 답변 받기"
                                  ) : item.checking_status === "guest" ? (
                                    "비회원 답변 받기 선택"
                                  ) : (
                                    ""
                                  )
                                ) : item.content === "keep-guest" ? (
                                  item.checking_status === null ? (
                                    "답변 받을 연락처 입력 중"
                                  ) : (
                                    "답변 받을 연락처 입력 완료"
                                  )
                                ) : item.content === "product-btn" ? (
                                  item.checking_status === "recommend" ? (
                                    "상품 추천 선택"
                                  ) : item.checking_status === "recommend02" ? (
                                    "구매 상품 문의 선택"
                                  ) : (
                                    "상품 추천 / 구매 상품 문의"
                                  )
                                ) : item.content === "delivery-btn" ? (
                                  item.checking_status === "delivery01" ? (
                                    "배송조회 선택"
                                  ) : item.checking_status === "delivery02" ? (
                                    "배송문의 선택"
                                  ) : (
                                    "배송조회 / 배송문의"
                                  )
                                ) : item.content === "claim-btn" ? (
                                  item.checking_status === "claim01" ? (
                                    "제안하러 가기 선택"
                                  ) : item.content === "claim02" ? (
                                    "오류 알리기 선택"
                                  ) : item.content === "again" ? (
                                    "처음으로 가기 선택"
                                  ) : (
                                    "제안하러 가기 / 오류 알리기 / 처음으로 가기"
                                  )
                                ) : item.content === "again" ? (
                                  item.checking_status === "again" ? (
                                    "처음으로 가기 선택"
                                  ) : (
                                    "처음으로 가기"
                                  )
                                ) : (
                                  item.content
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="inquiry-main-content-answer">
            <TextArea
              // onChange={handleTextChange}
              // onChange={(e) => console.log(e)}
              allowClear
              type="text"
              placeholder={"답변을 입력하세요"}
              disabled={isLoading}
              id={`answer-textarea`}
              // value={inquiryAnswer}
            />
            <div className="inquiry-main-content-action-wrap">
              <div className="inquiry-answer-alert-wrap">
                <Checkbox
                  checked={checkAlert}
                  onChange={(e) => setCheckAlert(e.target.checked)}
                >
                  알림 보내기
                </Checkbox>
              </div>
              <div
                onClick={() => {
                  // if (inquiryAnswerValidation && !isLoading && !inquiryEndType) {
                  if (!isLoading && !inquiryEndType) {
                    submitInquiryAnswer();
                  }
                }}
                className={
                  // (inquiryAnswerValidation && !isLoading && !inquiryEndType) ?
                  !isLoading && !inquiryEndType
                    ? "inquiry-main-content-action-active"
                    : "inquiry-main-content-action"
                }
              >
                전송
              </div>
            </div>
          </div>
        </div>
        <div className="inquiry-main-nutrients-wrap">
          <div className="add-padding">
            <div className="inquiry-main-recommend-header">선택 상품 추천</div>
            <div
              className="inquiry-sub-recommend-header"
              style={{ marginBottom: 10 }}
            >
              추천 상품 선택
            </div>
            <Search
              ref={searchInput}
              placeholder="상품명을 입력해주세요."
              onSearch={handleSearch}
            />
            <Table
              className="inquiry-recommend-product-search-table"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={productItemList}
              loading={isLoading}
              onRow={handleRowEvent}
              bordered
              size="small"
              rowKey="product_id"
              rowClassName="coupon-table-row"
              scroll={{ x: "max-content", y: "calc(170px - 48px)" }}
              tableLayout="auto"
              pagination={false}
            />
          </div>
          <Divider className="divider" style={{ marginBottom: 20 }} />
          <div className="add-padding">
            {/*    <div className="inquiry-sub-recommend-header" style={{ marginBottom: 10 }}>추천 이유</div>*/}
            {/*    <Search*/}
            {/*        ref={searchReasonInput}*/}
            {/*        placeholder="(,)로 구분하여 검색해주세요."*/}
            {/*        onSearch={handleSearchRecommendReason}*/}
            {/*    />*/}
            {/*    <Table*/}
            {/*        className="inquiry-recommend-product-search-table"*/}
            {/*        rowSelection={reasonRowSelection}*/}
            {/*        columns={reasonColumns}*/}
            {/*        dataSource={recommendReasonList}*/}
            {/*        loading={isLoading}*/}
            {/*        onRow={handleReasonRowEvent}*/}
            {/*        bordered*/}
            {/*        size="small"*/}
            {/*        rowKey="id"*/}
            {/*        rowClassName="coupon-table-row"*/}
            {/*        scroll={{x: 'max-content', y: 'calc(190px - 48px)'}}*/}
            {/*        tableLayout="auto"*/}
            {/*        pagination={false}*/}
            {/*        style={{ marginBottom: 50 }}*/}
            {/*    />*/}
            {/*    <Row wrap={false} className="inquiry-select-nutrients-header-wrap">*/}
            {/*        <Col flex="none"><div className="inquiry-sub-recommend-header">영양소</div></Col>*/}
            {/*        <Col flex="auto"><Row gutter={[0, 8]}>*/}
            {/*            {selectedNutrientsList?.length > 0 && (<>{selectedNutrientsList.map((nutrients, idx) =>*/}
            {/*                <Tag key={`select_nutrients_${idx}`} className="select-nutrients-tag" closable onClose={(e) => handleDeleteNutrients(nutrients.id, e)}>{nutrients.name}</Tag>*/}
            {/*            )}</>)}*/}
            {/*        </Row></Col>*/}
            {/*    </Row>*/}
            {/*    <Collapse*/}
            {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
            {/*        defaultActiveKey={['vitamin']}*/}
            {/*        expandIconPosition={"right"}*/}
            {/*    >*/}
            {/*        <Panel header="비타민" key="vitamin">*/}
            {/*            <Row style={{rowGap: 8}}>*/}
            {/*                {nutrientsList.vitamin.map((vitamin, idx) =>*/}
            {/*                    <Col span={8}>*/}
            {/*                        <Checkbox*/}
            {/*                            key={`vitamin_${idx}`}*/}
            {/*                            id={vitamin.id}*/}
            {/*                            name="nutrient_vitamin"*/}
            {/*                            value={vitamin}*/}
            {/*                            onChange={handleNutrientsSelect}*/}
            {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === vitamin.nutrient_id)}*/}
            {/*                        >{vitamin.nutrient_name}</Checkbox>*/}
            {/*                    </Col>)}*/}
            {/*            </Row>*/}
            {/*        </Panel>*/}
            {/*    </Collapse>*/}
            {/*    <Collapse*/}
            {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
            {/*        expandIconPosition={"right"}*/}
            {/*    >*/}
            {/*        <Panel header="미네랄" key="mineral">*/}
            {/*            <Row style={{rowGap: 8}}>*/}
            {/*                {nutrientsList.mineral.map((mineral, idx) =>*/}
            {/*                    <Col span={8}>*/}
            {/*                        <Checkbox*/}
            {/*                            key={`mineral_${idx}`}*/}
            {/*                            id={mineral.id}*/}
            {/*                            name="nutrient_mineral"*/}
            {/*                            value={mineral}*/}
            {/*                            onChange={handleNutrientsSelect}*/}
            {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === mineral.nutrient_id)}*/}
            {/*                        >{mineral.nutrient_name}</Checkbox>*/}
            {/*                    </Col>)}*/}
            {/*            </Row>*/}
            {/*        </Panel>*/}
            {/*    </Collapse>*/}
            {/*    <Collapse*/}
            {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
            {/*        expandIconPosition={"right"}*/}
            {/*        style={{ marginBottom: 55 }}*/}
            {/*    >*/}
            {/*        <Panel header="뉴트리션" key="nutrition">*/}
            {/*            <Row style={{rowGap: 8}}>*/}
            {/*                {nutrientsList.nutrition.map((nutrition, idx) =>*/}
            {/*                    <Col span={8}>*/}
            {/*                        <Checkbox*/}
            {/*                            key={`nutrition_${idx}`}*/}
            {/*                            id={nutrition.id}*/}
            {/*                            name="nutrient_nutrition"*/}
            {/*                            value={nutrition}*/}
            {/*                            onChange={handleNutrientsSelect}*/}
            {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === nutrition.nutrient_id)}*/}
            {/*                        >{nutrition.nutrient_name}</Checkbox>*/}
            {/*                    </Col>)}*/}
            {/*            </Row>*/}
            {/*        </Panel>*/}
            {/*    </Collapse>*/}
            <div
              className="inquiry-sub-recommend-header"
              style={{ marginBottom: 12 }}
            >
              인삿말
            </div>
            <TextArea
              allowClear
              className="inquiry-recommend-product-greetings-wrap"
              name="greetings"
              value={recommendInquiryAnswer.greetings}
              onChange={(e) =>
                setRecommendInquiryAnswer({
                  ...recommendInquiryAnswer,
                  [e.target.name]: e.target.value,
                })
              }
            />
            {selectedProductList.map((row, idx) => {
              if (idx === 0) {
                return (
                  <>
                    <div
                      className="inquiry-sub-recommend-header"
                      style={{ marginBottom: 12, marginTop: 20 }}
                    >
                      상품 추천 이유
                    </div>
                    <RecommendProductComponent
                      productInfo={row}
                      currIdx={idx}
                      deleteRecommendProduct={deleteRecommendProduct}
                      recommendProductReason={recommendProductReason}
                      selectedRow={selectedProductList}
                      selectedNutrients={selectedNutrientsList}
                      handleNutrientsSelect={handleNutrientsSelectForProduct}
                    />
                  </>
                );
              } else {
                return (
                  <RecommendProductComponent
                    productInfo={row}
                    currIdx={idx}
                    deleteRecommendProduct={deleteRecommendProduct}
                    recommendProductReason={recommendProductReason}
                    selectedRow={selectedProductList}
                    selectedNutrients={selectedNutrientsList}
                    handleNutrientsSelect={handleNutrientsSelectForProduct}
                  />
                );
              }
            })}
          </div>
          <Divider className="divider" />
          <div className="add-padding">
            <div
              className="inquiry-sub-recommend-header"
              style={{ marginBottom: 12 }}
            >
              추가 코멘트
            </div>
            <TextArea
              allowClear
              name="additional"
              value={recommendInquiryAnswer.additional}
              onChange={(e) =>
                setRecommendInquiryAnswer({
                  ...recommendInquiryAnswer,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </div>
          <Divider className="divider" style={{ marginBottom: 14 }} />
          <div className="inquiry-main-recommend-button-wrap">
            <Button
              className={
                "inquiry-main-recommend-button" +
                (validRecommendProduct() ? "" : " disalbed")
              }
              onClick={recommendProductAnswer}
              disabled={!validRecommendProduct()}
            >
              선택 상품 추천하기
            </Button>
            <Button
              className="inquiry-main-recommend-cancel-button"
              onClick={() => {
                if (window.confirm("해당 내용들을 정말 초기화하시겠습니까?")) {
                  recommendProductInitial();
                }
              }}
            >
              초기화
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InquiryManageComponent;
